import { render } from "./LuckyStatistics1000x.vue?vue&type=template&id=f24345d8"
import script from "./LuckyStatistics1000x.vue?vue&type=script&lang=js"
export * from "./LuckyStatistics1000x.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__